import type { ReactNode } from 'react'
import type { MenuItem } from '../components/DropdownMenu'
import Navbar from '../core/Navbar'

interface MainLayoutProps {
  children: ReactNode
  appName: string
  navItems?: MenuItem[]
  rightSlot?: ReactNode
}

const MainLayout = ({
  children,
  appName,
  navItems,
  rightSlot,
}: MainLayoutProps) => {
  return (
    <>
      <Navbar appName={appName} navItems={navItems} rightSlot={rightSlot} />
      <main>{children}</main>
    </>
  )
}

export { MainLayout }
